import type { AutocompleteProps, TextFieldProps } from "@mui/material"
import { type FieldValues } from "react-hook-form"

import AutoCompleteInput from "@components/text_input/sub_components/autocomplete"
import PhoneInput from "@components/text_input/sub_components/phone_input"
import PrimaryInput, {
  TextInputProps
} from "@components/text_input/sub_components/primary_input"
import SearchInput from "@components/text_input/sub_components/search_input"

export default function TextInput<
  T extends FieldValues,
  K = { label: string; value: string }
>(props: TextInputProps<T, K>) {
  if ((props as unknown as TextFieldProps)?.type === "phone") {
    return <PhoneInput {...props} />
  }
  if (
    (
      props as unknown as TextFieldProps &
        AutocompleteProps<T, boolean, boolean, boolean, React.ElementType>
    )?.type === "select"
  ) {
    return <AutoCompleteInput {...props} />
  }
  if ((props as unknown as TextFieldProps)?.type === "search") {
    return <SearchInput {...props} />
  }

  return <PrimaryInput {...props} />
}
